import { Promise } from "es6-promise-polyfill"
import { BoxGeometry, MeshBasicMaterial, Mesh, MeshLambertMaterial, Vector3, Plane } from "three";
import Cannon from "cannon";

const material = new MeshLambertMaterial({
    color: 0x004400
});

export default class Cube
{
    constructor(position, ctx, height)
    {

        const cube = new Mesh(
            new BoxGeometry( 1, 1, height),
            material
        );

        ctx.scene.add( cube );

        //console.log({center,quat, position});

        cube.position.copy(position);
        //cube.quaternion.copy(quat);
        //cube.position.z += height/2;

        const shape = new Cannon.Box(new Cannon.Vec3(
            1,
            1,
            height
        ));
        const body = new Cannon.Body({
            mass: 0,
            material: ctx.defaultMaterial
        });

        body.position.copy(position);

        body.quaternion.copy(cube.quaternion);

        body.addShape(shape);
        // body.angularVelocity.set(0,10,0);
        // body.angularDamping = 0.5;

        this.body = body;

        ctx.world.addBody(body);

        this.cube = cube;
    }

}



// WEBPACK FOOTER //
// ./src/cube.js